import { render } from "./rtv.vue?vue&type=template&id=55fabfc6&scoped=true"
import script from "./rtv.vue?vue&type=script&lang=js"
export * from "./rtv.vue?vue&type=script&lang=js"

import "./rtv.vue?vue&type=style&index=0&id=55fabfc6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55fabfc6"]])

export default __exports__